import { useState } from "react";

import { Trans, useTranslation } from "react-i18next";

import { ApiResources } from "@/api/resources";
import InfoIconWithTooltip from "@/components/IconsWithTooltips/InfoIconWithTooltip/InfoIconWithTooltip";
import RectangleLoader from "@/shared/components/loaders/RectangleLoader";
import { useDashboardStore } from "@/stores/useDashboardStore";

import { ROUTES, useMediaQueries } from "../../../../../shared";
import CardWrapper from "../../../CardWrapper/CardWrapper";
import ChartWrapper from "../../../shared/ChartWrapper/ChartWrapper";
import DownloadStatus from "../DownloadStatus/DownloadStatus";
import useResourceDownloadsStatus from "../hooks/useResourceDownloadsStatus";

const DriverDownloads = () => {
  const { t } = useTranslation();
  const { toSm, toMd } = useMediaQueries();
  const { isDashboardLoading, driverDownloadsError, driverDownloadsStatus } =
    useDashboardStore();

  const { isLoading: isDriverDownloadsStatusLoading } =
    useResourceDownloadsStatus(ApiResources.DashboardDriverDownloads);

  const [showBackButton, setShowBackButton] = useState<boolean>(false);
  const [backButton, setBackButton] = useState<Element | null>(null);

  const isLoading = isDriverDownloadsStatusLoading || isDashboardLoading;

  return (
    <CardWrapper
      cardTitle={t("Dashboard##driver downloads")}
      isError={driverDownloadsError}
      isDashboardDownloads={!toSm}
      isInnerCard
      isLoading={isLoading}
      titleInlineAction={showBackButton && <>{backButton}</>}
      titleExtention={
        <InfoIconWithTooltip
          title={<Trans i18nKey="Dashboard##card tooltips##driver downloads" />}
          iconTestId="driver-downloads-info icon"
          tooltipSize="medium"
        />
      }
    >
      <ChartWrapper hasTabs={false}>
        {isLoading ? (
          <RectangleLoader
            width="100%"
            height="100%"
            customStyle={
              toMd && {
                minHeight: "252px"
              }
            }
            testId="driver-downloads-card-loader"
          />
        ) : (
          <DownloadStatus
            resourceDownloadLocation={ROUTES.Drivers}
            resourceDownloadStatus={driverDownloadsStatus}
            isDownloadStatusLoading={isDriverDownloadsStatusLoading}
            setShowBackButton={setShowBackButton}
            setBackButton={setBackButton}
          />
        )}
      </ChartWrapper>
    </CardWrapper>
  );
};

export default DriverDownloads;
